import React from "react"
import { Col, Container, Row } from "reactstrap"
import AdminOffersCards from "./AdminOffersCards"
import DashboardFundRequests from "./DashboardFundRequests"
import AmountPayableChart from "./AmountPayableChart"
import DashbordCompanies from "./DashbordCompanies"
import { useSelector } from "react-redux"
import DashbordWealthPartners from "./DashbordWealthPartners"
import WealthPatnerChart from "./WealthPatnerChart"
import MaturityTracking from "./MaturityTracking"

const AdminDashboard = () => {
  const { currentUserMenuType } = useSelector((state) => state.common)
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={12}>
              <div className="container-wrapper-box">
                <div className="container-wrapper-left-box">
                  <AdminOffersCards />
                  <DashboardFundRequests />
                  <div className="chart-section-wrapper">
                    {currentUserMenuType === "WEALTH_PARTNER" ? (
                      <WealthPatnerChart />
                    ) : (
                      <AmountPayableChart />
                    )}
                  </div>
                </div>
                <div className="container-wrapper-right-box">
                  {currentUserMenuType === "WEALTH_PARTNER" && (
                    <DashbordWealthPartners />
                  )}
                  <DashbordCompanies />
                  <MaturityTracking />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AdminDashboard
